import { formatFromInUrl, getQueryForm } from '@/utils/instantLoaded/toolsWithoutDeps';
import {
  App,
  AppConfig,
  defaultAppConfig,
  useDefaultABTestConfigList,
  useLiveChatSdkAppList,
  DirectlyToLiveChat,
} from './constants';
import { ENTRY_POINT } from '@/types/entryPoints';

export const getSearchUrl = () => {
  return window.location.search || window.CsChat?.searchUrl || '';
};

export const getFromInUrl = () => {
  const searchUrl = getSearchUrl();
  const from = getQueryForm('from', searchUrl);

  return from;
};

export const getPageBeforeHcInUrl = () => {
  const searchUrl = getSearchUrl();
  const pageBeforeHc = getQueryForm('page_before_hc', searchUrl);
  return pageBeforeHc;
};

export const getConfig = () => {
  const from = getFromInUrl();
  const allConfig = Object.values(AppConfig).reduce((acc, cur) => {
    return acc.concat(cur);
  }, []);

  return allConfig.find((c) => c.fromInUrl === from) || defaultAppConfig;
};

export const isBank = () => {
  const platform = process.env.platform;
  if (platform && ['bank', 'bankID', 'bankSG'].includes(platform)) {
    return true;
  }
  const { app } = getConfig();
  return app === App.Bank;
};

export const useDefaultConfig = () => {
  const { app } = getConfig();
  return useDefaultABTestConfigList.includes(app);
};

export const isDriver = () => {
  const { app } = getConfig();
  return app === App.Driver;
};

export const isDriverVN = () => {
  const { app } = getConfig();
  return app === App.Driver && getFromInUrl() === 'ShopeeFoodVNDriverHC';
};

export const isFood = () => {
  const { app } = getConfig();
  return app === App.Food;
};

export const isDriverOrFood = () => {
  return isDriver() || isFood();
};

export const isShopee = () => {
  const { app } = getConfig();
  return app === App.Shopee;
};

export const isDriverSupportChatbot = () => {
  const searchUrl = getSearchUrl();
  return getQueryForm('toLiveChat', searchUrl) !== DirectlyToLiveChat.Yes;
};

export const isSupportChatbot = () => {
  const { isSupportChatbot, hasChatbotCountries } = getConfig();
  return isSupportChatbot && hasChatbotCountries.includes(COUNTRY);
};


const anotherAppSupportEntrypoints = [ENTRY_POINT.ShopeeFoodVNDriverHC];
export const isSupportComposedInitSession = () => {
  const entryPointInUrl = getFromInUrl();
  if (!entryPointInUrl) {
    return false;
  }

  const entrypoint = formatFromInUrl(entryPointInUrl) as number;
  return (isShopee() || isBank() || anotherAppSupportEntrypoints.includes(entrypoint)) && isSupportChatbot();
};

// 注意：这里的 live chat SDK 是指客户端集成了 native SDK(这个 SDK 提供了类似 Shopee 中的 bridge 功能)，
// 代码中还有一个 live chat SDK 是指提供了客服聊天功能的 SDK，这个 SDK 由 Channel 团队开发，
// 希望后续有时间可以调整一下这两个 SDK 命名，误导性太大了😄😄😄
export const UseLiveChatSDKApp = {
  is: () => {
    const { app } = getConfig();
    return useLiveChatSdkAppList.includes(app);
  },
  supportChatbot: () => UseLiveChatSDKApp.is() && isSupportChatbot(),
  // 支持 chatbot 的入口，是否命中 chatbot 灰度， 目前只有 bank id 有这个灰度
  isHitChatbotGray: true,
};

export const getChatbotHost = () => {
  const { isCommonHost } = getConfig();
  const hostname = window.location.hostname;
  return `https://${isCommonHost ? 'common.' : ''}${hostname}`;
};
